import React from "react";

import { Tag, Collapse, Button, Table, Space, Input } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";

import moment from "moment";

const { Panel } = Collapse;

class TableOne extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    tableOneData: this.props.tableOneData,
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, paddingLeft: "5px", paddingRight: "5px" }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters , confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  render() {
    const { tableOneData } = this.props;

    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        // width: "200px",
      },
      {
        title: "User Name",
        dataIndex: "user_name",
        key: "user_name",
        // width: "200px",
      },
      {
        title: "Email",
        dataIndex: "send_email",
        key: "send_email",
        // width: "200px",
        // ...this.getColumnSearchProps("user_name"),
        // fixed: 'left',
        // sorter: (a, b) => a.user_name ? a.user_name.localeCompare(b.user_name) : null
      },

      {
        title: "Token Type",
        dataIndex: "token_type",
        key: "token_type",
        // width: "150px",
        align: "center",
      },
      {
        title: "Invitation Sent Date",
        dataIndex: "invitation_sent_date",
        key: "invitation_sent_date",
        // width: "250px",

        render: (text, record) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Invitation expiration Date",
        dataIndex: "invitation_expiration_date",
        key: "invitation_expiration_date",
        // width: "250px",

        render: (text, record) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        // width: "200px",
        align: "center",
        render: (status) => {
          if (status === "Active") {
            return <Tag color="blue">{status}</Tag>;
          } else if (status === "Done") {
            return <Tag color="green">{status}</Tag>;
          } else {
            return <Tag color="red">{status}</Tag>;
          }
        },
      },
      {
        title: "Create by",
        dataIndex: "create_by",
        key: "create_by",
        // width: "200px",
      },
    ];

    return (
      <div>
        <Collapse defaultActiveKey={["3_1"]} expandIconPosition="end">
          <Panel header="User Invitation" key="3_1">
            <div className="is_table_3">
              <Table
                columns={columns}
                dataSource={tableOneData}
                // size="small"
                pagination={false}
                rowKey="_id"
                scroll={{ x: 1100 }}
              />
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default TableOne;
